import { render, staticRenderFns } from "./icon-glosario1.vue?vue&type=template&id=23944be7&scoped=true&"
import script from "./icon-glosario1.vue?vue&type=script&lang=js&"
export * from "./icon-glosario1.vue?vue&type=script&lang=js&"
import style0 from "./icon-glosario1.vue?vue&type=style&index=0&id=23944be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23944be7",
  null
  
)

export default component.exports